import React from 'react';
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { getUser } from "../utils/Common";

/**
 * Last panel on the dashboard grid: activate an existing camera or
 * order new JobSight cameras.
 */
export default function AddCameraPanel({ onActivateCap, onOrderCap }) {
  const history = useHistory();
  const user = getUser();

  // Builder admins/billing can actually order; app ADMINs see the button
  // for visibility but it doesn't link to anything.
  const orderEnabled = !!(user &&
    (user.builderStatus === 'ADMIN' || user.builderStatus === 'BILLING') &&
    user.builderId);
  const showOrderButton = orderEnabled || user?.role === 'ADMIN';

  const handleActivateCap = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onActivateCap) {
      onActivateCap();
    } else {
      history.push('/signupnewcap');
    }
  };

  const handleOrderCap = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onOrderCap) {
      onOrderCap();
    } else {
      history.push('/orders');
    }
  };

  return (
    <div className="add-camera-panel">
      <div className="add-camera-badge" aria-hidden="true" />
      <h3 className="add-camera-title">Add Camera</h3>
      <p className="add-camera-subtitle">Activate or order new JobSight Cameras below.</p>
      <div className="add-camera-actions">
        <Button block className="btn-brand-dark" onClick={handleActivateCap}>
          Activate Camera
        </Button>
        {showOrderButton && (
          <Button
            block
            className="btn-brand-yellow"
            onClick={orderEnabled ? handleOrderCap : (e) => e.preventDefault()}
          >
            Order New Cameras
          </Button>
        )}
      </div>
    </div>
  );
}
